import Vue from 'vue';
import iziToast from 'izitoast';
//import '../../node_modules/izitoast/dist/css/iziToast.css';
import '../lib/iziToast_custem.css';

// Here you can include some "default" settings
iziToast.settings({
  position: 'topRight',
  close: false,
  //backgroundColor: '#24ec12e6',
  messageColor: 'white',
  pauseOnHover: false,
  timeout: 5000,
  zindex: 999999,
  layout: 2
})
// and export it
export default function install () {
  Object.defineProperties(Vue.prototype, {
    $iziToast: {
      get () {
        return iziToast
      }
    }
  })
}